import React from 'react'
import { Box, ImageLoader } from '@usap/uicomponents'
import { disableStyle } from '../constant'

const ItemImage = props => {
  const {
    imageHeight,
    itemOrderId,
    eligibleRMA,
    imageUrlSrc,
    imageText,
  } = { ...props }
  return (
    <Box
      style={eligibleRMA ? null : disableStyle}
      alignSelf="start"
      justify="center"
      width="216px"
      margin="medium"
      height={imageHeight}
    >
      <ImageLoader
        key={`RMA${itemOrderId}`}
        width="100%"
        height="100%"
        src={imageUrlSrc}
        fit="contain"
        alt={imageText}
        cloudinaryParams="h_125,w_125"
        fallback="https://cld.partsimg.com/image/upload/noimage.jpg"
      />
    </Box>
  )
}

export default ItemImage
